import L from "leaflet";
import type { PoiKind } from "../types";
import type { ParsedPoi } from "./types";
import { getPoiColorClass, KIND_FILL, KIND_BORDER } from "./types";

/** Simple round marker icon tinted by POI kind (for the sidebar coloured dot). */
export function makePoiIcon(kind: PoiKind): L.DivIcon {
  const color = KIND_FILL[kind];
  return L.divIcon({
    className: "",
    html: `<div style="width:14px;height:14px;border-radius:50%;background:${color};border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.4);"></div>`,
    iconSize: [14, 14],
    iconAnchor: [7, 7],
  });
}

/**
 * Two-layer DivIcon:
 *   • inner circle: detour-time colour (green / yellow / red / grey)
 *   • thin border:  POI-kind colour (navy for toilet, red for Orlen, …)
 */
export function makePoiIconWithColor(poi: ParsedPoi): L.DivIcon {
  const cls = getPoiColorClass(poi);
  const fillMap: Record<string, string> = {
    "poi-color-green":  "#22c55e",
    "poi-color-yellow": "#eab308",
    "poi-color-red":    "#ef4444",
    "poi-color-grey":   "#94a3b8",
  };
  const fillColor   = fillMap[cls] ?? "#94a3b8";
  const borderColor = KIND_BORDER[poi.kind];
  const opacity    = poi.liveMissed ? 0.5 : 1;
  const SIZE = 14;

  return L.divIcon({
    className: "",
    html: `<div style="position:relative;width:${SIZE}px;height:${SIZE}px;">
      <div style="
        position:absolute;
        width:${SIZE}px;height:${SIZE}px;
        border-radius:50%;
        background:${poi.liveMissed ? "#9ca3af" : fillColor};
        border:1.5px solid ${borderColor};
        box-sizing:border-box;
        opacity:${opacity};
      "></div>
    </div>`,
    iconSize:    [SIZE, SIZE],
    iconAnchor:  [SIZE / 2, SIZE / 2],
    popupAnchor: [0, -(SIZE / 2)],
  });
}

/** Coloured dot HTML string for the POI list header. */
export function kindDotStyle(kind: PoiKind): string {
  const bg = KIND_FILL[kind];
  return `width:12px;height:12px;border-radius:50%;flex-shrink:0;margin-top:4px;background:${bg};`;
}
